import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import impact from "../../../assets/images/impact.png";

const Impact = () => {
  return (
    <Grid container padding={{ xs: "30% 0%", sm: "4% 2% 7% 0%" }}>
      <Grid items xs={12} sm={12}>
        <Typography
          variant="h3"
          fontWeight={700}
          padding={{ xs: "4% 0%", sm: "4% 0% 2% 0%" }}
          color={"#fff"}
          textAlign={"center"}
        >
          AIR Fund led-impact at a Glance
        </Typography>
      </Grid>
      <Grid items xs={12} sm={12} padding={{ xs: "4% 0%", sm: "1% 0%" }}>
        <Box
          component="img"
          height={{ xs: "78px", sm: "250px" }}
          sx={{
            objectFit: "cover",
            overflow: "hidden",
            width: "100%",
          }}
          src={impact}
          alt={"icons"}
        />
      </Grid>
    </Grid>
  );
};

export default Impact;
